import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Grid, lighten, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionMultiSelectButtonDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const defaultDelay = 350;
  const theme = useTheme();

  const [exclusiveAnswerSelected, setExclusiveAnswerSelected] = useState(false);

  const [localAnswer, setLocalAnswer] = useState([]);

  useEffect(() => {
    if (question.answerValue) {
      setLocalAnswer(question.answerValue);

      if (question.answerValue.length === 1) {
        for (let i = 0; i < question.answerOptions.length; i++) {
          if (question.answerOptions[i].value === question.answerValue[0]) {
            setExclusiveAnswerSelected(true);
          }
        }
      }
    }
  }, [question, setExclusiveAnswerSelected]);

  useEffect(() => {
    if (localAnswer.length === 0) {
      onAnswerSelected(null);
    } else {
      onAnswerSelected(localAnswer);
    }
  }, [localAnswer, onAnswerSelected]);

  return (
    <Fragment>
      {question.answerOptions.map((answerOption, index) => (
        <Grid
          id={`questionGrid${index}`}
          key={uuid()}
          container
          item
          xs={11}
          justifyContent="center"
          spacing={2}
        >
          <Tooltip title={answerOption.helpText || ""} placement="left">
            <Fragment>
              <OmniAssessmentValueTextFab
                key={`answerOption${uuid()}`}
                color="primary"
                size="large"
                variant={answerOption.value === "unsure" ? "outlined" : "contained"}
                onClick={e => {
                  e.stopPropagation();
                  if (answerOption.isExclusive) {
                    setLocalAnswer([answerOption.value]);
                    onAnswerSelected([answerOption.value]);
                    setExclusiveAnswerSelected(true);
                    startNextTimer(defaultDelay);
                  } else if (exclusiveAnswerSelected) {
                    setLocalAnswer([answerOption.value]);
                    onAnswerSelected([answerOption.value]);
                    setExclusiveAnswerSelected(false);
                  } else {
                    let newAnswer = [];
                    if (localAnswer.includes(answerOption.value)) {
                      newAnswer = localAnswer.filter(ans => ans !== answerOption.value);
                    } else {
                      newAnswer = [...localAnswer, answerOption.value];
                    }
                    setLocalAnswer(newAnswer);
                    setExclusiveAnswerSelected(false);
                  }
                }}
                sx={[
                  { width: "100%" },
                  ((localAnswer && answerOption.value === localAnswer[0]) ||
                    (!localAnswer &&
                      question.answerValue &&
                      question.answerValue.includes(answerOption.value))) && {
                    boxShadow: `inset 0px 0px 1px 1px ${lighten(theme.palette.primary.dark, 0.15)}`,
                  },
                  (answerOption.value === "unsure" ||
                    (question.answerValue &&
                      question.answerValue.includes(answerOption.value))) && {
                    "&:hover": { color: theme.palette.primary.contrastText },
                  },
                ]}
              >
                <Grid
                  container
                  justifyContent="center"
                  direction="row"
                  sx={{ width: "100%", alignItems: "center" }}
                >
                  <Grid item justifySelf="center" xs>
                    <Typography
                      key={uuid()}
                      variant="button"
                      dangerouslySetInnerHTML={getAnswerTextAsHTML(answerOption.text)}
                    />
                  </Grid>

                  <CheckCircleRoundedIcon
                    sx={[
                      {
                        position: "absolute",
                        top: 8,
                        right: 16,
                        maxWidth: "32px",
                        maxHeight: "32px",
                        alignSelf: "baseline",
                        display: "none",
                        opacity: 0,
                      },
                      ((localAnswer && localAnswer.includes(answerOption.value)) ||
                        (!localAnswer &&
                          question.answerValue &&
                          question.answerValue.includes(answerOption.value))) && {
                        display: "unset",
                        opacity: 1,
                      },
                    ]}
                  />
                </Grid>
                {answerOption.subText && (
                  <Typography
                    variant="caption"
                    dangerouslySetInnerHTML={getAnswerTextAsHTML(answerOption.subText)}
                  />
                )}
              </OmniAssessmentValueTextFab>
            </Fragment>
          </Tooltip>
        </Grid>
      ))}
    </Fragment>
  );
};

export default QuestionMultiSelectButtonDisplay;
